import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  LedgerTotal as LedgerTotalComponent,
  LedgerTotalProps,
} from "../../components/LedgerTotal/LedgerTotal";
import { getLedgerHead as getLedgerHeadAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getLedgerHead,
  getRewardRequestStatus,
  getWidgetConfig,
} from "../../reducers/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

interface LedgerTotalContainerProps extends LedgerTotalProps {
  getLedgerHeadAction: typeof getLedgerHeadAction;
  ledgerHead: ReturnType<typeof getLedgerHead>;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  currency?: string;
}

class LedgerTotal extends React.Component<LedgerTotalContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );
    const hasConfig = get(this.props.config, "settings") != null;
    // Only fetch when we have config so we use the correct currency (e.g. reward store ledgerCurrency, not "loyalty").
    if (
      isCustomerAuthenticated &&
      hasConfig &&
      this.props.requestStatus.getLedger !== "REQUESTING"
    ) {
      this.props.getLedgerHeadAction({ currency: this.resolveCurrency() });
    }
  }

  componentDidUpdate(prevProps: LedgerTotalContainerProps) {
    const authenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );
    const prevHasSettings = get(prevProps.config, "settings") != null;
    const hasSettings = get(this.props.config, "settings") != null;
    // Fetch only when we have config (resolveCurrency uses settings.ledgerCurrency; without config we'd use "loyalty").
    // Single gate avoids double fetch when auth and config arrive in the same cycle.
    const shouldFetch =
      authenticated &&
      this.props.requestStatus.getLedger !== "REQUESTING" &&
      ((customerAuthenticationOccurred(prevProps.data, this.props.data) &&
        hasSettings) ||
        (hasSettings && !prevHasSettings));
    if (shouldFetch) {
      this.props.getLedgerHeadAction({ currency: this.resolveCurrency() });
    }
  }

  render() {
    return <LedgerTotalComponent {...this.props} />;
  }

  private resolveCurrency(): string {
    return (
      this.props.currency ||
      (get(this.props.config, "settings.ledgerCurrency") as
        | string
        | undefined) ||
      "loyalty"
    );
  }
}

function mapStateToProp(
  state: StoreState
): Pick<LedgerTotalProps, "ledgerHead" | "requestStatus" | "currencyLabel"> {
  return {
    ledgerHead: getLedgerHead(state),
    requestStatus: getRewardRequestStatus(state),
    currencyLabel: get(getWidgetConfig(state), "settings.currencyLabel") as
      | string
      | undefined,
  };
}

export default connect(mapStateToProp, {
  getLedgerHeadAction,
})(LedgerTotal);
